module.exports = __webpack_public_path__ + "img/SellAnywhere_Website1.6914bb54.png";